<ng-container *ngIf="qualifications && qualifications.value.length !== 0">
    <h3>Du har lagt till dessa behörigheter i din ansökan</h3>
    <app-table [formGroup]="qualifications">
        <thead>
            <tr>
                <td scope="col">Behörighet</td>
                <td scope="col">Grunder</td>
                <td scope="col"></td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of tableRows; let i = index" [formGroupName]="i">
                <td [innerHtml]="row.qual" label="Behörighet"></td>
                <td [innerHtml]="row.basis" label="Grunder"></td>
                <td label="Ta bort">
                    <button class="btn btn--secondary btn--small" (click)="qualifications.removeAt(i)"
                        [attr.aria-label]="'ta bort ' + row.qual.split('<br/>').join(', ')">
                        <svg focusable="false" class="skv-icon skv-icon--inline">
                            <use xlink:href="#material-icon-delete"></use>
                        </svg>
                    </button>
                </td>
            </tr>
        </tbody>
    </app-table>
</ng-container>